module.exports = __webpack_public_path__ + "static/media/4-3-ducha-sv-seslal.12f971a1.jpg";